import React from 'react';

function UserMenu ({ auth } = {}) {
  const { user } = auth;
  return [
    {
      text: user
        ? <small>{user.name}</small>
        : 'Loading...',
      icon: 'user-circle'
    },
    {
      text: 'Log Out',
      icon: 'power-off',
      url: '/RLX/logout'
    }
  ];
};

export default UserMenu;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Config/Menus/UserMenu.jsx